module.exports = __webpack_public_path__ + "static/media/phone.76af22db.svg";